import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import styles from './AlertTemplate.module.scss';
import SuccessIcon from './icons/SuccessIcon';
import ErrorIcon from './icons/ErrorIcon';
import CloseIcon from './icons/CloseIcon';

function AlertTemplate(props) {
  const startTimer = (id) => {
    setTimeout(() => {
      props.close(id);
    }, 7000);
  };

  return (
    <div className={styles.container}>
      <TransitionGroup>
        {props.messages.map((message) => {
          startTimer(message.id);
          const { success } = message;

          return (
            <CSSTransition key={message.id} timeout={400} classNames="fade">
              <div className={cn(styles.alert, success ? styles.success : '')}>
                {success && <SuccessIcon />}
                {message.error && <ErrorIcon />}
                <span>{message.text}</span>

                <button onClick={() => props.close(message.id)}>
                  <CloseIcon />
                </button>
              </div>
            </CSSTransition>
          );
        })}
      </TransitionGroup>
    </div>
  );
}

export default AlertTemplate;

AlertTemplate.defaultProps = {
  messages: [],
};

AlertTemplate.propTypes = {
  messages: PropTypes.arrayOf(
    PropTypes.shape({
      success: PropTypes.bool,
      error: PropTypes.bool,
      text: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
    }),
  ),
  close: PropTypes.func.isRequired,
};
